// All assets — ONLY user-uploaded ONYX content. No stock imagery.

// Official Onyx logos
export const LOGO_DARK = "https://customer-assets.emergentagent.com/job_onyx-premium-reserve/artifacts/sjym8bm5_b623322b-3f2f-464f-8186-10972c9259c3-1581cab0.png";
export const LOGO_LIGHT = "https://customer-assets.emergentagent.com/job_d067dda8-b284-4a23-bddb-a730a8ff782e/artifacts/benml2j5_IMG_4644.png";
export const LOGO_FULL = "https://customer-assets.emergentagent.com/job_d067dda8-b284-4a23-bddb-a730a8ff782e/artifacts/2xm9r7zr_1B92307B-7270-4190-96DF-F4E41637CE77.jpeg";

// Floor plans (provided)
export const FLOORPLAN_MAIN = "https://customer-assets.emergentagent.com/job_d067dda8-b284-4a23-bddb-a730a8ff782e/artifacts/p4wto6py_320df224-3655-4e77-b07b-8e414046d1e4.png";
export const FLOORPLAN_MEZZ = "https://customer-assets.emergentagent.com/job_d067dda8-b284-4a23-bddb-a730a8ff782e/artifacts/06pzhfgd_dda11b2a-e2e5-4138-8eb2-50ebc1a12aae.png";

// Photos uploaded by client (Onyx Rooftop DC official photography)
export const PHOTO_BOTTLE_GIRL = "https://customer-assets.emergentagent.com/job_onyx-premium-reserve/artifacts/czvhghni_5357319119-1200x1500.jpeg";
export const PHOTO_GROUP_DUPONT = "https://customer-assets.emergentagent.com/job_onyx-premium-reserve/artifacts/qkk0ql8g_DSC04757.jpg";
export const PHOTO_HOOKAH = "https://customer-assets.emergentagent.com/job_onyx-premium-reserve/artifacts/462nrnx0_DSC04709.jpg";
export const PHOTO_CROWD = "https://customer-assets.emergentagent.com/job_onyx-premium-reserve/artifacts/ejo9cftd_DSC09950.jpg";
export const PHOTO_DANCEFLOOR = "https://customer-assets.emergentagent.com/job_onyx-premium-reserve/artifacts/f6vizzb0_DSC05361.jpg";
export const PHOTO_RED_DRESS_1 = "https://customer-assets.emergentagent.com/job_onyx-premium-reserve/artifacts/fdb09ujz_DSC05626.jpg";
export const PHOTO_RED_DRESS_2 = "https://customer-assets.emergentagent.com/job_onyx-premium-reserve/artifacts/eyxoongb_DSC05640.jpg";
export const PHOTO_PINK_SEQUIN = "https://customer-assets.emergentagent.com/job_onyx-premium-reserve/artifacts/t8v0i4xz_DSC05653.jpg";
export const PHOTO_PINK_DRINK = "https://customer-assets.emergentagent.com/job_onyx-premium-reserve/artifacts/83gmlvoo_DSC05397.jpg";

// Curated lists
export const GALLERY_PHOTOS = [
  { url: PHOTO_BOTTLE_GIRL, caption: "Saturday nights at Onyx" },
  { url: PHOTO_DANCEFLOOR, caption: "Peak hour energy" },
  { url: PHOTO_RED_DRESS_1, caption: "Red-carpet ready" },
  { url: PHOTO_GROUP_DUPONT, caption: "Dupont After Dark" },
  { url: PHOTO_RED_DRESS_2, caption: "Squad nights" },
  { url: PHOTO_HOOKAH, caption: "Hookah lounge ambience" },
  { url: PHOTO_PINK_SEQUIN, caption: "Onyx style" },
  { url: PHOTO_CROWD, caption: "House-music Sundays" },
  { url: PHOTO_PINK_DRINK, caption: "Signature cocktails" },
];

export const HERO_PHOTO = PHOTO_BOTTLE_GIRL;
export const VIP_HERO_PHOTO = PHOTO_DANCEFLOOR;
